'use client';
import React, { useEffect, useRef, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import reactHtmlParser from 'react-html-parser';
import { ImgParallax } from '@/components/common/ui/images/ImgParallax';
import Link from 'next/link';
import useContainerOffset from '@/components/hooks/useContainerOffset';
import useDeviceTypeMobile from '@/components/hooks/useDeviceTypeMobile';
import { StyledInnerBannerDetails } from '@/components/common/ygen/sections/inner-banner-details/inner-banner-details-style';
import { usePathname } from 'next/navigation';
import { CURSOR_HIDE, CURSOR_SHOW, CURSOR_TEXT, DispatchCursor } from 'haspr-cursor';

const InnerBanner = ({ data, imageScroll, inidustry }) => {

	const bannerImge = data?.images?.list?.find((f) => f?.banner === 'on');
	const bannerImgeVideo = data?.images?.list?.find((f) => f?.is_video === 'on');
	const thumbImage = data?.images?.list?.find((f) => f?.thumb === 'on');
	const offset = useContainerOffset('.container');
	const isMobile = useDeviceTypeMobile();
	const [wrapperHeight, setWrapperHeight] = useState(false);
	const location = usePathname()
	useEffect(() => {
		if (document.querySelector('.inner-banner-details')?.offsetHeight) {
			setWrapperHeight(document.querySelector('.inner-banner-details')?.offsetHeight);
		}
	}, [wrapperHeight]);

	const videoRef = useRef(null);

	useEffect(() => {
		const video = videoRef.current;
		if (video) {
			const playPromise = video.play();
			if (playPromise !== undefined) {
				playPromise
					.then(() => {
						// Autoplay started
					})
					.catch((error) => {
						console.warn('Autoplay was prevented:', error);
					});
			}
		}
	}, []);

	return (
		<>
			<StyledInnerBannerDetails  offset={offset} getHeight={wrapperHeight}  className={`InnerBanner ${imageScroll ? 'forImageScroll' : ''} ${bannerImge?.for_project === 'on' ? 'for_projects' : ''}`} data-scroll-section>

				{
					bannerImgeVideo ?
						<div className={'global-image'}>
							<video
								ref={videoRef}
								src={bannerImgeVideo?.short_desc ? bannerImgeVideo?.short_desc : location === '/industries-empowered' ? '/images/industry.mp4' : location === '/solution-spectrum' ? '/images/solution.mp4' : null}
								autoPlay
								muted
								loop
								playsInline
								preload="none"
							/>
						</div>

						:
						imageScroll ?
							<ImgParallax banner={true} src={data?.images ? bannerImge?.full_path : ''} />

							:
							<ImgParallax parallax banner={true} src={data?.images ? bannerImge?.full_path : ''} />


				}
				<Container>
					<Row>
						<Col md={3}>
							<ul className={'d-flex justify-content-start breadcrumb-ygen'}>
								{
									inidustry &&
									<>
										<li>
											<Link href={'/'}>
												Home
											</Link>
										</li>
										<li>/</li>
									</>
								}
								<li>
									<Link href={inidustry ? '/industries-empowered' : '/'}>
										{inidustry ? 'Industries Empowered' : 'Home'}
									</Link>
								</li>
								<li>/</li>
								<li>
									{
										data?.section_data?.subtitle &&
										<h1 className={``}>{reactHtmlParser(data?.section_data?.subtitle)}</h1>

									}
								</li>
							</ul>

						</Col>
					</Row>
				</Container>
				{
					!isMobile &&
					<div data-scroll className={'inner-banner-details'} style={{ backgroundImage: `url("${thumbImage?.full_path}")`, paddingLeft: offset + 15 + 'px' }}>
						<div className="wrapper">
							<Container>
								<Row>
									<Col md={10}>
										{
											data?.section_data?.short_desc &&
											<h3 className={``}>{reactHtmlParser(data?.section_data?.short_desc)}</h3>

										}
										{
											data?.section_data?.description &&
											reactHtmlParser(data?.section_data?.description)

										}
									</Col>
								</Row>
							</Container>
						</div>
					</div>

				}

			</StyledInnerBannerDetails>
			{
				isMobile &&
				<StyledInnerBannerDetails className={'forMobileOne'}>
					<div className={'inner-banner-details'} style={{ backgroundImage: `url("${thumbImage?.full_path}")`, paddingLeft: offset + 15 + 'px' }}>
						<div className="wrapper">
							<Container>
								<Row>
									<Col md={10}>
										{
											data?.section_data?.short_desc &&
											<h3 className={`fade-up`}>{reactHtmlParser(data?.section_data?.short_desc)}</h3>

										}
										{
											data?.section_data?.description &&
											reactHtmlParser(data?.section_data?.description)

										}
									</Col>
								</Row>
							</Container>
						</div>
					</div>

				</StyledInnerBannerDetails>
			}
		</>
	);
};


export default React.memo(InnerBanner);
